import React, { useState, useEffect, useRef } from "react";
import Loader from "../loader/loader";
import ManageShift from "./ManageShift";
import { useGetAllShiftMutation, useGetShiftByIdMutation } from "./Api";
import Pagination from "../Pagination/Pagination";
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

const ScheduleShift = () => {

    const [getAllShiftApi, { isLoading }] = useGetAllShiftMutation()
    const [getShiftByIdApi, { isLoading: getShiftByIdLoading }] = useGetShiftByIdMutation()

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [status, setStatus] = useState(false)
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    const [shifts, SetShifts] = useState([])

    const requestIdRef = useRef(0);
    const navigate = useNavigate()

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000); // 1000ms delay

        return () => clearTimeout(handler); // cleanup on next effect
    }, [search]);

    useEffect(() => {
        getAllShiftStatus()
    }, [rowsPerPage, currentPage, status, debouncedSearch]);

    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearch]);

    const getAllShiftStatus = async () => {
        try {
            const requestId = ++requestIdRef.current;

            const response = await getAllShiftApi({
                page: currentPage,
                limit: rowsPerPage,
                search: debouncedSearch.trim()
            })

            if (requestId !== requestIdRef.current) return;

            if (response?.data?.success) {
                SetShifts(response?.data?.data?.scheduleShifts)
                setTotalRecords(response?.data?.data?.pagination?.total || 0);
                setTotalPages(response?.data?.data?.pagination?.totalPages || 1);
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }


    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);


    // Drawer open close
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);


    // Open drawer for creating new category
    const handleCreateShift = () => {
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleSave = () => {
        handleCloseDrawer(); // Close 
        setStatus(!status)  // for get new data after new role upload
    };


    // // Update Drawer

    const [isUpdateDrawerOpen, setIsUpdateDrawerOpen] = useState(false);
    const [shiftData, setShiftData] = useState()

    const handleUpdateCloseDrawer = () => {
        setIsUpdateDrawerOpen(false);
    };

    const handleUpdateSave = () => {
        handleUpdateCloseDrawer(); // close toggle
        setStatus(!status)  // for get new data after new role upload
    };


    const getShiftById = async (id) => {
        try {
            const response = await getShiftByIdApi({ id: id })

            if (response?.data?.success) {
                setIsUpdateDrawerOpen(true)
                setShiftData(response?.data?.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || getShiftByIdLoading ? <Loader /> :
                <div>
                    {/* Header */}
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <ul className="breadcrumb mb-0">
                                <li className="breadcrumb-item">Schedule Shift</li>
                                <li className="breadcrumb-item active">Shift Management</li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="row">
                            <div className="p-6">
                                {/* Title */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h3 className="h4 mb-1 drawer-header">
                                            Shift Management
                                        </h3>
                                        <p className="mb-0 text-muted">
                                            Manage schedule shifts
                                        </p>
                                    </div>
                                    <button className="btn btn-primary"
                                        onClick={handleCreateShift}
                                    >
                                        Add Shift
                                    </button>
                                </div>


                                <div className="card p-3 mb-4">

                                    <div className="card shadow-sm border-0 p-3 mb-4">
                                        <div className="row justify-content-end g-3">

                                            {/* Search */}
                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                {/* <label className="form-label small text-muted mb-1">Search</label> */}
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search Shift by name..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Shift Name</th>
                                                    <th>Shift Start</th>
                                                    <th>Shift End</th>
                                                    <th>Total Hours</th>
                                                    <th>Created By</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isLoading && shifts?.length > 0 ? shifts?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {item.shiftName}
                                                        </td>
                                                        <td>
                                                            {item.shiftStart}
                                                        </td>
                                                        <td>
                                                            {item.shiftEnd}

                                                        </td>
                                                        <td>
                                                            {item.totalHours}
                                                        </td>
                                                        <td>
                                                            {item.uploaded_by_name}
                                                        </td>
                                                        <td style={{ cursor: "pointer" }}
                                                            onClick={() => getShiftById(item.id)}
                                                        >
                                                            <FaEdit size={18} />
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                                            No data found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {/* Pagination */}

                                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                                            <div className="d-flex align-items-center gap-1 small">

                                                <span>Show</span>

                                                <select
                                                    className="form-select form-select-sm page-size-select"
                                                    value={rowsPerPage}
                                                    onChange={(e) => {
                                                        setRowsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={15}>15</option>
                                                </select>

                                                <span>entries</span>

                                            </div>

                                            <div className="small text-muted">
                                                Showing {startEntry} to {endEntry} of {totalRecords} entries
                                            </div>

                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                maxPagesToShow={rowsPerPage}
                                                onPageChange={(page) => setCurrentPage(page)}
                                            />

                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {isDrawerOpen && (
                        <ManageShift
                            mode="add"
                            onClose={handleCloseDrawer}
                            onSave={handleSave}
                        />

                    )}

                    {isUpdateDrawerOpen && (
                        <ManageShift
                            mode="update"
                            onClose={handleUpdateCloseDrawer}
                            onSave={handleUpdateSave}
                            data={shiftData}
                        />
                    )}
                </div>

            }
        </div>

    );
};

export default ScheduleShift;

